export default "__VITE_ASSET__DGALP72e__"